import React, { useState, useEffect } from 'react';
import Header from '../JobPage/Header';
import Footer from '../JobPage/Footer';
import useCompanies from '../Hooks/useCompanies';
import useJob from '../HireWithUs/Hooks/jobHook';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import useJobsByCompany from '../Hooks/useJobsByCompany';
import { Container } from '@/Components/ui/container';
import { Stack, Grid } from '@/Components/ui/layout';
import { Inline } from '@/Components/ui/layout';
import { Heading } from '@/Components/ui/typography';
import { Text } from '@/Components/ui/typography';
import { Button } from '@/Components/ui/button';
import { Badge } from '@/Components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/Components/ui/card';
import { Separator } from '@/Components/ui/separator';
import { cn } from '@/lib/utils';

const CompanyOverview = () => {
  const jobCategories = [
    { title: 'Customer Success', count: 3500 },
    { title: 'Customer Success', count: 3500 },
    { title: 'Customer Success', count: 3500 },
    { title: 'Customer Success', count: 3500 },
    { title: 'Customer Success', count: 3500 },
  ];

  const jobLocations = [
    { title: 'Customer Success', count: 3500 },
    { title: 'Customer Success', count: 3500 },
    { title: 'Customer Success', count: 3500 },
    { title: 'Customer Success', count: 3500 },
    { title: 'Customer Success', count: 3500 },
  ];

  const techTools = [
    { title: 'Customer Success', count: 3500 },
    { title: 'Customer Success', count: 3500 },
    { title: 'Customer Success', count: 3500 },
    { title: 'Customer Success', count: 3500 },
    { title: 'Customer Success', count: 3500 },
  ];

  const { compnayId } = useParams();
  const companies = useCompanies();
  const jobData = useJobsByCompany(compnayId);
  const [company, setCompany] = useState(null);
  const navigate = useNavigate();

  const handleViewAllJobsClick = () => {
    navigate(`/companyspecificjobs/${compnayId}`);
  };

  useEffect(() => {
    if (companies && companies.length > 0) {
      const selectedCompany = companies.find(
        (company) => company.id === parseInt(compnayId)
      );
      setCompany(selectedCompany);
    }
  }, [companies, compnayId]);

  if (!company) {
    return <div>Loading...</div>;
  }

  return (
    <div className="bg-background text-foreground min-h-screen flex flex-col">
      <div className="sticky top-0 z-[1000] w-full">
        <Header />
      </div>
      <Container size="default" className="flex-1">
        <div className="flex gap-8 mt-8 mb-24">
          <aside className="w-[217px] flex-shrink-0">
            <Stack spacing="md" className="mt-[-800px]">
              <Stack spacing="sm">
                <Heading level="h1" className="text-xl font-light tracking-wide">
                  {company.companyName}
                </Heading>
                <Button 
                  variant="default" 
                  className="mt-4 flex items-center gap-2.5 justify-center text-lg font-light tracking-wide"
                >
                  <img 
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/16df8363450149acedc55d6ca653c0b044eeac55d14ca093aebe6f28f0332c62?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
                    alt="Follow icon" 
                    className="w-[30px] h-[30px]"
                  />
                  Follow
                </Button>
              </Stack>
              
              <nav className="mt-2">
                <Stack spacing="xs" className="w-full">
                  <a href="#overview" className="text-lg font-light tracking-wide py-2.5 px-2.5 text-foreground hover:text-primary transition-colors">
                    Overview
                  </a>
                  <a href="#jobs" className="text-lg font-light tracking-wide py-2.5 px-2.5 text-foreground hover:text-primary transition-colors">
                    Jobs
                  </a>
                  <a href="#financial" className="text-lg font-light tracking-wide py-2.5 px-2.5 text-foreground hover:text-primary transition-colors">
                    Financial
                  </a>
                  <a href="#products" className="text-lg font-light tracking-wide py-2.5 px-2.5 text-foreground hover:text-primary transition-colors">
                    Products
                  </a>
                  <a href="#culture" className="text-lg font-light tracking-wide py-2.5 px-2.5 text-foreground hover:text-primary transition-colors">
                    Culture
                  </a>
                  <a href="#ranking-awards" className="text-lg font-light tracking-wide py-2.5 px-2.5 text-foreground hover:text-primary transition-colors">
                    Ranking & Awards
                  </a>
                  <a href="#layoffs" className="text-lg font-light tracking-wide py-2.5 px-2.5 text-foreground hover:text-primary transition-colors">
                    Layoffs
                  </a>
                  <a href="#policies" className="text-lg font-light tracking-wide py-2.5 px-2.5 text-foreground hover:text-primary transition-colors">
                    Policies
                  </a>
                  <a href="#top-posts" className="text-lg font-light tracking-wide py-2.5 px-2.5 text-foreground hover:text-primary transition-colors">
                    Top Posts
                  </a>
                  <a href="#diversity" className="text-lg font-light tracking-wide py-2.5 px-2.5 text-foreground hover:text-primary transition-colors">
                    Diversity
                  </a>
                  <a href="#other-info" className="text-lg font-light tracking-wide py-2.5 px-2.5 text-foreground hover:text-primary transition-colors">
                    Other info
                  </a>
                </Stack>
              </nav>
            </Stack>
          </aside>

          <section className="flex-1 ml-[350px] mt-[-800px]">
            <Stack spacing="xl">
              <Stack spacing="lg" className="mt-[-20px]">
                <Inline spacing="md" align="center" className="mb-4">
                  <img 
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/400ff50bf84ead1ec02b0259ceec4cc5b06dd8d6ae061df209173b37a61130bb?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
                    alt="Overview icon" 
                    className="w-[50px] h-[50px]"
                  />
                  <Heading level="h2" className="text-[35px] font-semibold tracking-wide">
                    Overview
                  </Heading>
                </Inline>
                <Separator />
                <Heading level="h2" className="text-2xl">
                  {company.industryType}
                </Heading>
                <Text size="base" className="mt-6 tracking-wide">
                  {company.aboutUs}
                </Text>
                
                <Grid cols={3} gap="lg" className="mt-8">
                  <Stack spacing="sm">
                    <Text size="lg" className="text-muted-foreground tracking-wide">Founded</Text>
                    <Text size="base" className="tracking-wide">{company.yearOfEstablishment}</Text>
                  </Stack>
                  <Stack spacing="sm">
                    <Text size="lg" className="text-muted-foreground tracking-wide">HQ</Text>
                    <Inline spacing="sm" align="center">
                      <img 
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/7f6c140495c2bb3713a56a2fe1ab7a0b8077e03de4e56a94ae163ebc9b4aea1a?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
                        alt="Location icon" 
                        className="w-4 h-4"
                      />
                      <Text size="base" className="tracking-wide">{company.mapLocation}</Text>
                    </Inline>
                  </Stack>
                  <Stack spacing="sm">
                    <Text size="lg" className="text-muted-foreground tracking-wide">Employees</Text>
                    <Text size="base" className="tracking-wide">{company.teamSize}</Text>
                  </Stack>
                  <Stack spacing="sm">
                    <Text size="lg" className="text-muted-foreground tracking-wide">Valuation</Text>
                    <Text size="base" className="tracking-wide">$2,852 B</Text>
                  </Stack>
                  <Stack spacing="sm">
                    <Text size="lg" className="text-muted-foreground tracking-wide">Type</Text>
                    <Text size="base" className="tracking-wide">{company.organizationType}</Text>
                  </Stack>
                  <Stack spacing="sm">
                    <Text size="lg" className="text-muted-foreground tracking-wide">Tags</Text>
                    <Badge variant="outline" className="w-fit">
                      {company.industryType}
                    </Badge>
                  </Stack>
                </Grid>
              </Stack>

              <Stack spacing="lg" className="mt-10">
                <Inline spacing="md" align="center" className="mb-4">
                  <img 
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/8ab3e5d5a62be59bfd39550a8f9a2d51db326e21d4b8b34ec7018ed4d6b2eb1b?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
                    alt="Jobs icon" 
                    className="w-[50px] h-[50px]"
                  />
                  <Heading level="h2" className="text-[35px] font-semibold tracking-wide">
                    Jobs
                  </Heading>
                </Inline>
                <Separator />
                
                <Inline justify="between" align="center" className="mt-14">
                  <Card className="w-[50%] h-[150px]">
                    <CardContent className="p-4">
                      <Text size="xl" className="font-normal tracking-wide">Open jobs</Text>
                      <Text size="4xl" className="font-semibold tracking-wide mt-8">
                        {jobData.length}
                      </Text>
                    </CardContent>
                  </Card>
                  <Button 
                    variant="default" 
                    className="flex items-center gap-8 text-xl font-normal tracking-wide mt-8"
                    onClick={handleViewAllJobsClick}
                  >
                    View all jobs
                    <img 
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/ae97cabca905dc2df08e55cd93a31cfcf5437d144f2efeb942633a24332f0924?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
                      alt="Arrow right" 
                      className="w-[50px] h-[50px]"
                    />
                  </Button>
                </Inline>

                <Stack spacing="xl" className="mt-[70px]">
                  <Stack spacing="lg" className="mt-[60px]">
                    <Heading level="h3" className="text-[25px] font-semibold tracking-wide mt-[90px]">
                      Top Job Categories
                    </Heading>
                    <Stack spacing="md" className="mt-8">
                      {jobCategories.map((category, index) => (
                        <Inline key={index} justify="between" className="text-lg text-muted-foreground tracking-wide mb-4">
                          <Text size="lg">{category.title}</Text>
                          <Text size="lg">{category.count}</Text>
                        </Inline>
                      ))}
                    </Stack>
                  </Stack>
                  
                  <Stack spacing="lg" className="mt-[60px]">
                    <Heading level="h3" className="text-[25px] font-semibold tracking-wide mt-[90px]">
                      Top Job Location
                    </Heading>
                    <Stack spacing="md" className="mt-8">
                      {jobLocations.map((location, index) => (
                        <Inline key={index} justify="between" className="text-lg text-muted-foreground tracking-wide mb-4">
                          <Text size="lg">{location.title}</Text>
                          <Text size="lg">{location.count}</Text>
                        </Inline>
                      ))}
                    </Stack>
                  </Stack>
                  
                  <Stack spacing="lg" className="mt-[60px]">
                    <Heading level="h3" className="text-[25px] font-semibold tracking-wide mt-[90px]">
                      Top Tech/Tools Mentioned
                    </Heading>
                    <Stack spacing="md" className="mt-8">
                      {techTools.map((tool, index) => (
                        <Inline key={index} justify="between" className="text-lg text-muted-foreground tracking-wide mb-4">
                          <Text size="lg">{tool.title}</Text>
                          <Text size="lg">{tool.count}</Text>
                        </Inline>
                      ))}
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </section>
        </div>
      </Container>
      <Footer />
    </div>
  );
};

export default CompanyOverview;
